export class BruteForceGameConfig {
    public static totalReels: number = 5;
    public static totalRows: number = 5;
    public static symbolWidth: number = 120;
    public static symbolHeight: number = 96;
    public static reelSetPositionX: number = 71;
    public static reelSetPositionY: number = 120;
    public static arcadeScreenWidth: number = 720;
    public static arcadeScreenHeight: number = 576;

    public static SCATTER_ANTICIPATION_DELAY_NORMAL: number = 3;
    public static SCATTER_ANTICIPATION_DELAY_FAST: number = 2;


    public static isScatterAnticipationOnReelActive: boolean[] = [false, false, false, false, false];
    public static nudgeMaxMultiplierConfig: { [type: number]: number } = {1: 8, 2: 21, 3: 51};

    public static GAME_SYMBOLS: string[] = ["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5", "XN_1", "XN_2", "XN_3", "SC"];

    public static nudgePresentationFirstSkip: boolean = false;
    public static nudgePresentationSecondSkip: boolean = false;
    public static initialWinPresentationSkip: boolean = false;

}